import { render, staticRenderFns } from "./Dashboard-User.vue?vue&type=template&id=a84022b4&scoped=true"
import script from "./Dashboard-User.js?vue&type=script&lang=js&external"
export * from "./Dashboard-User.js?vue&type=script&lang=js&external"
import style0 from "./Dashboard-User.vue?vue&type=style&index=0&id=a84022b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a84022b4",
  null
  
)

export default component.exports